export const API_ENDPOINTS = {
  // Django endpoints use trailing slashes
  FIREBLOCKS_VAULT_ACCOUNTS: '/api/fireblocks/vault-accounts/',
  FIREBLOCKS_VAULT_ACCOUNT_ASSET_ADDRESSES: '/api/fireblocks/vault-account-asset-addresses/',
  XRPL: '/api/fireblocks/xrpl/',
  TOKENIZED_ASSET_POOL: '/api/v1/tokenizedassetpool/',
  BOND_PRICE: '/api/v1/bondprice',
};
